import {GET_CLIP_MOMENTS} from './types';

export function getClipMoments(cid) {
    return (dispatch) => {
        dispatch({
            type: GET_CLIP_MOMENTS,
            payload: [
                {
                    "id": 1,
                    "cid": 1163944854,
                    "title": "abc",
                    "startTime": "00:22:21",
                    "endTime": "00:22:24",
                    "tags": "Funny,Comedy"
                },
                {
                    "id": 2,
                    "cid": 2222222,
                    "title": "def",
                    "startTime": "00:22:21",
                    "endTime": "00:22:24",
                    "tags": "Funny,Comedy"
                }


            ]
        })
    }
}